import { Component, OnInit, Input, Output, forwardRef, EventEmitter, DoCheck, IterableDiffers } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, FormControl, FormGroup} from '@angular/forms';
import { AbstractControl } from '@angular/forms/src/model';
import { Select2OptionData } from 'ng2-select2';
import { UtilService } from '../../../util/util.service';
declare var $: any;

const noop = () => {
};

@Component({
  selector: 'ats-campo-select2',
  templateUrl: './campo-select2.component.html',
  styleUrls: ['./campo-select2.component.css'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CampoSelect2Component), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => CampoSelect2Component), multi: true }
  ]

})
export class CampoSelect2Component implements ControlValueAccessor, Validator, DoCheck, OnInit {

  @Input() label: string = '';
  @Input() formControlName: string = null;
  @Input() formGroup: FormGroup = null;
  @Input() className: string = '';
  @Input() placeholder: string = '';
  @Input() urlAjax: string = null;
  @Input() campoObrigatorio: boolean = false;
  @Input() allowClear: boolean = false;
  @Input() multiple: boolean = false;
  @Input() removeLabel: boolean = false;
  @Input() data: Array<Select2OptionData> = [];
  value: string[] = [];
  @Input() pageLength: number = 20;
  @Input() desativado: boolean = false;
  @Input() processaResultado?: (data: any) => any = function(obj) {return {id: obj.id, text: obj.nome};};

  @Output()
  change: EventEmitter<string[]> = new EventEmitter<string[]>();

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  public options: Select2Options;
  public ajaxOptions: Select2AjaxOptions;

  private idComponent: number;
  public classCampo : string;
  public classError : string;
  private inputCampo : string;
  private errorCampo : string;

  differData: any;
  //differValue: any;

  constructor(differs: IterableDiffers) {
    this.differData = differs.find([]).create(null);
   // this.differValue = differs.find([]).create(null);
   }

   ngDoCheck() {
    var changesData = this.differData.diff(this.data);
    //var changesValue = this.differValue.diff(this.formGroup.controls[this.formControlName].value);

		if(changesData) {
      if(changesData.forEachChangedItem != undefined ||
         changesData.forEachAddedItem != undefined ||
         changesData.forEachRemovedItem != undefined){
            $(this.inputCampo).select2(this.options);
            $(this.inputCampo).val(this.formGroup.controls[this.formControlName].value).trigger('change');
      }
    }

		// if(changesValue) {
    //   if(changesValue.forEachChangedItem != undefined ||
    //      changesValue.forEachAddedItem != undefined ||
    //      changesValue.forEachRemovedItem != undefined){
    //         $(this.inputCampo).val(this.formGroup.controls[this.formControlName].value).trigger('change');
    //   }
		// }

	}

  ngOnInit() {
    var self = this;
    this.idComponent = Math.floor(Math.random() * 600) + 1;
    this.classCampo = 'campo-select2-' + this.idComponent;
    this.classError = 'error-campo-select2-' + this.idComponent;
    this.inputCampo = 'select.' + this.classCampo;
    this.errorCampo = 'div.' + this.classError;

    if(self.data == undefined || self.data == null){
      self.data = [];
    }

    this.options = {
      theme: 'bootstrap',
      language: 'pt-BR',
      allowClear: self.allowClear,
      multiple: self.multiple,
      data: self.data,
      placeholder: self.placeholder
    }

    if(self.urlAjax != undefined && self.urlAjax != null){
      self.ajaxOptions = {
        url: self.urlAjax,
        dataType: 'json',
        delay: 250,
        cache: false,
        data: (params: any) => {
            return {
                query: params.term,
                page: params.page,
                pageLength: self.pageLength
            }
        },
        processResults: (data: any, params: any) => {
            params.page = params.page || 1;
            return {
                results: $.map(data.aaData, self.processaResultado),
                pagination: {
                    more: (params.page * self.pageLength) < data.iTotalDisplayRecords
                }
            };
        },
      };

      self.options.ajax = self.ajaxOptions;

    }else{
      self.options.data = self.data;
    }

    // if(!UtilService.empty(self.formGroup) &&
    //    !UtilService.empty(self.formControlName) &&
    //    !UtilService.empty(self.formGroup.controls[self.formControlName]) &&
    //    !UtilService.empty(self.formGroup.controls[self.formControlName].value) ){
    //   self.value = self.formGroup.controls[self.formControlName].value;
    // }

    $( document ).ready(function() {
      $(self.inputCampo).select2(self.options);

//      if(self.value != undefined && self.value != null){
      $(self.inputCampo).val(self.formGroup.controls[self.formControlName].value).trigger('change');
  //    }

      // $(self.inputCampo).on('select2:select', function (e) {
      //   var data = e.params.data;

      //   if(self.multiple && self.urlAjax != undefined && self.urlAjax != null){
      //     var existe: boolean = false;
      //    // var temp = self.data != null && self.data.length > 0 ? self.data.find(item => item.id == data.id) : null;

      //     if(self.data != null && self.data.length > 0){
      //       self.data.forEach((item, index) => {
      //         if(item.id == data.id){
      //           existe = true;
      //         }
      //       })
      //     }

      //     if(!existe){
      //      // self.data.push({id: data.id, text: data.text});
      //     }
      //   }

      // });

      $(self.inputCampo).on('change', function (e) {
        var input = this;
        self.value = $(this).val();

        if(self.formGroup != undefined && self.formGroup != null && self.formControlName != undefined && self.formControlName != null && self.formControlName != ''){
          if(self.multiple){
            self.formGroup.controls[self.formControlName].setValue(self.value);
            self.formGroup.controls[self.formControlName].updateValueAndValidity();
          }else{
           // UtilService.limparArray(self.formGroup.controls[self.formControlName].value);
            self.formGroup.controls[self.formControlName].setValue(self.value);
            self.value = self.formGroup.controls[self.formControlName].value;
            self.formGroup.controls[self.formControlName].updateValueAndValidity();
            //self.formGroup.controls[self.formControlName].setValue([self.value]);
          }
        }

        $(input).removeClass('ng-valid').removeClass('ng-invalid');

        if(self.campoObrigatorio && (self.value == undefined || self.value == null || self.value.length <= 0)){
          $(input).addClass('ng-invalid');
          $(self.errorCampo).html('Campo obrigatório');
          $(self.errorCampo).show();
        }else{
            $(input).addClass('ng-valid');
            $(self.errorCampo).hide();
        }

      });

    });

  }


  public writeValue(value: any) {
    this.change.emit(this.formGroup.controls[this.formControlName].value);
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  validaSelect(c: AbstractControl) : any{
    var value: string = '';
    var retorno : any = {};

    $(this.inputCampo).removeClass('ng-valid').removeClass('ng-invalid');

    if((c.value != undefined && c.value != null) || (c.value != undefined && c.value != null && c.value[this.formControlName] != undefined)){

      if(c.value != undefined && c.value != null && c.value[this.formControlName] != undefined){
          value = c.value[this.formControlName];
      }else{
          value = c.value;
      }

      if(this.campoObrigatorio && (value == undefined || value == null || value == '' || value.length <= 0)){
        retorno['validateSelectObrigatorio'] = {};
        retorno['validateSelectObrigatorio']['valid'] = false;
        $(this.inputCampo).addClass('ng-invalid');
      }else{
          retorno = null;
          $(this.inputCampo).addClass('ng-valid');
      }
    }else{
      retorno = null;
    }

    return retorno;
}

  public validate(c: FormControl) {
    return this.validaSelect(c);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/componentes/campo-select2/campo-select2.component.ts